import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, object=user
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem("pa_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("pa_token");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = (token, userData) => {
    localStorage.setItem("pa_token", token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("pa_token");
    setUser(false);
  };

  const updateTokens = (tokens) => {
    setUser((u) => (u && typeof u === "object" ? { ...u, tokens } : u));
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, updateTokens, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
